<ng-container *ngIf="data">
  <div class="alert alert-{{data.MsgType ||'info'}} alert-inline mt-3" role="alert"
    [attr.data-qa]="'ret-account-messaging'">
    <span class="sr-only">info</span>
    <h5 class="h3 alert-title mb-2">{{data.MsgTitle}}</h5>
    <p class="msg-body" [innerHtml]="data.MsgBody | safeHtml"></p>
    <p *ngIf="data?.ctaLink">
      <a [href]="data.ctaLink?.trim()"><strong>{{data.ctaTxt}}</strong><span class="sr-only" *ngIf="data.SROnly"> {{data.SROnly}}</span></a>
    </p>
    <p class="msg-body mb-2" [innerHtml]="data.disclaimer | safeHtml"></p>
  </div>
</ng-container>